import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Typography, Select, Button, message, Popconfirm } from 'antd';
import {
  getProject,
  getServiceDeskProject,
  getIssues,
  updateSkill,
} from '../skills_action';

const { Text } = Typography;
const { Option } = Select;

class DefaultsSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectsLodaing: false,
      saveLoading: false,
      issueTypeLoading: false,
      ...this.initialState,
    };
  }

  initialState = {
    defaultProject: {},
    defaultIssueType: {},
    editMode: false,
  };

  componentDidMount() {
    this.getProjectsData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.match.params.sub_skill !== this.props.match.params.sub_skill
    ) {
      this.getProjectsData();
    }
  }

  getProjectsData = () => {
    const { sub_skill } = this.props.match.params;
    this.setState({ ...this.initialState });
    if (sub_skill === 'jira_service_desk') {
      // this.props.getServiceDeskProject(this.props.match.params.wId, this.props.match.params.skill_id, {}).then((res) => {
      //   this.setvalues();
      // });
      this.setvalues();
    } else if (sub_skill === 'jira_software') {
      // this.props.getProject(this.props.match.params.wId).then((res) => {
      //   this.setvalues();
      // });
      this.setvalues();
    }
  };

  onChangeProject = (value, event) => {
    const { sub_skill } = this.props.match.params;
    this.setState({
      defaultProject: event.project,
      defaultIssueType: {},
      issueTypeLoading: true,
    });
    this.props
      .getIssues(
        this.props.match.params.wId,
        event.key,
        sub_skill === 'jira_software' ? false : true,
        sub_skill === 'jira_software' ? false : true
      )
      .then((res) => {
        if (res.data.success && res.data.issueTypes)
          this.setState({ issueTypeLoading: false });
        // if (res.data.success && res.data.issueTypes && res.data.issueTypes[0]) this.setState({ defaultIssueType: res.data.issueTypes[0] });
      });
  };

  onChangeIssue = (value, event) => {
    this.setState({
      defaultIssueType: event && event.issueType ? event.issueType : {},
    });
  };

  handleSave = () => {
    const { defaultProject, defaultIssueType } = this.state;
    const { jiraSkill } = this.props;
    const { sub_skill } = this.props.match.params;
    this.setState({ saveLoading: true });
    let data = {};

    if (
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.globalDefaults
    )
      data = { globalDefaults: jiraSkill.skill_metadata.globalDefaults };
    if (!data.globalDefaults) data.globalDefaults = {};
    if (sub_skill === 'jira_software') {
      data.globalDefaults.issueDefaults = {
        defaultProject,
        defaultIssueType,
      };
    } else if (sub_skill === 'jira_service_desk') {
      data.globalDefaults.ticketDefaults = {
        defaultProject,
        // defaultRequestType: defaultIssueType,
      };
      if (defaultIssueType && defaultIssueType.id)
        data.globalDefaults.ticketDefaults.defaultRequestType =
          defaultIssueType;
    }

    this.props
      .updateSkill(
        this.props.match.params.skill_id,
        this.props.match.params.wId,
        data
      )
      .then((res) => {
        if (res.data.success) {
          this.setState({ saveLoading: false, editMode: false });
        }
      });
  };

  handleCancel = () => {
    this.setState({ editMode: false });
    this.setvalues();
  };

  setvalues = () => {
    const { jiraSkill } = this.props;
    const { sub_skill } = this.props.match.params;

    if (sub_skill === 'jira_service_desk') {
      if (
        jiraSkill &&
        jiraSkill.skill_metadata.globalDefaults &&
        jiraSkill.skill_metadata.globalDefaults.ticketDefaults &&
        jiraSkill.skill_metadata.globalDefaults.ticketDefaults.defaultProject &&
        jiraSkill.skill_metadata.globalDefaults.ticketDefaults.defaultProject.id
        // jiraSkill.skill_metadata.globalDefaults.ticketDefaults.defaultRequestType &&
        // jiraSkill.skill_metadata.globalDefaults.ticketDefaults.defaultRequestType.id
      ) {
        this.setState({
          defaultProject:
            jiraSkill.skill_metadata.globalDefaults.ticketDefaults
              .defaultProject,
          defaultIssueType:
            jiraSkill.skill_metadata.globalDefaults.ticketDefaults
              .defaultRequestType || {},
        });
        this.props.getIssues(
          this.props.match.params.wId,
          jiraSkill.skill_metadata.globalDefaults.ticketDefaults.defaultProject
            .id,
          true,
          true
        );
      }
    } else if (sub_skill === 'jira_software') {
      if (
        jiraSkill &&
        jiraSkill.skill_metadata.globalDefaults &&
        jiraSkill.skill_metadata.globalDefaults.issueDefaults &&
        jiraSkill.skill_metadata.globalDefaults.issueDefaults.defaultProject &&
        jiraSkill.skill_metadata.globalDefaults.issueDefaults.defaultProject
          .id &&
        jiraSkill.skill_metadata.globalDefaults.issueDefaults
          .defaultIssueType &&
        jiraSkill.skill_metadata.globalDefaults.issueDefaults.defaultIssueType
          .id
      ) {
        this.setState({
          defaultProject:
            jiraSkill.skill_metadata.globalDefaults.issueDefaults
              .defaultProject,
          defaultIssueType:
            jiraSkill.skill_metadata.globalDefaults.issueDefaults
              .defaultIssueType,
        });
        this.props.getIssues(
          this.props.match.params.wId,
          jiraSkill.skill_metadata.globalDefaults.issueDefaults.defaultProject
            .id
        );
      }
    }
  };

  handleDelete = () => {
    this.setState({ saveLoading: true });
    const { jiraSkill } = this.props;

    let data = {};

    if (
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.globalDefaults
    )
      data = { globalDefaults: jiraSkill.skill_metadata.globalDefaults };
    if (!data.globalDefaults) data.globalDefaults = {};

    if (this.props.match.params.sub_skill === 'jira_service_desk')
      delete data.globalDefaults.ticketDefaults;
    else if (this.props.match.params.sub_skill === 'jira_software')
      delete data.globalDefaults.issueDefaults;

    this.props
      .updateSkill(
        this.props.match.params.skill_id,
        this.props.match.params.wId,
        data
      )
      .then((res) => {
        if (res.data.success) {
          message.success('Request defaults deleted succesfully!');
          this.setState({
            saveLoading: false,
            defaultProject: {},
            defaultIssueType: {},
          });
        }
      });
  };

  render() {
    const { jsd_projects, jiraSkill, projects } = this.props;
    const { defaultProject, defaultIssueType, editMode } = this.state;
    const { sub_skill } = this.props.match.params;

    let projectsArr = [],
      projectOptions = [];
    if (sub_skill === 'jira_service_desk') {
      projectsArr = jsd_projects ? [...jsd_projects] : [];
      projectOptions = projectsArr.map((project, index) => (
        <Option key={project.id} value={project.projectId} project={project}>
          {project.projectName + ` (${project.projectKey})`}
        </Option>
      ));
    } else if (sub_skill === 'jira_software') {
      projectsArr = projects ? [...projects] : [];
      projectsArr = projectsArr.filter(
        (pro) =>
          pro.projectTypeKey === 'software' || pro.projectTypeKey === 'business'
      );
      projectOptions = projectsArr.map((project, index) => (
        <Option key={project.id} value={project.id} project={project}>
          {project.name + ` (${project.key})`}
        </Option>
      ));
    }

    let useRestrictedRequestTypes = false,
      restrictedRequestTypes = [];
    if (
      sub_skill === 'jira_service_desk' &&
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.globalRequestTypeRestriction &&
      defaultProject &&
      jiraSkill.skill_metadata.globalRequestTypeRestriction.find(
        (restriction) =>
          restriction.project.projectId === defaultProject.projectId
      )
    ) {
      useRestrictedRequestTypes = true;
      restrictedRequestTypes =
        jiraSkill.skill_metadata.globalRequestTypeRestriction.find(
          (restriction) =>
            restriction.project.projectId === defaultProject.projectId
        ).requestTypes;
    }
    return (
      <>
        <div style={{ marginBottom: 16 }}>
          <Text strong>Creation Defaults: </Text>
          <Text type='secondary'>
            Set global defaults for{' '}
            {sub_skill === 'jira_service_desk' ? 'request' : 'issue'} creation.
            When channel or personal defaults are set, it will override the
            global defaults.
          </Text>
        </div>
        {/* <div>
          <Text type='secondary' strong>
            Default Project
          </Text>
          <br />
          <Select
            style={{ marginBottom: "8px", width: 300 }}
            name='defaultProject'
            value={defaultProject.projectId}
            onChange={this.onChangeProject}
            showSearch={true}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            disabled={!editMode}
          >
            {projectsArr.map((project, index) => (
              <Option key={project.id} value={project.projectId} project={project}>
                {project.projectName + ` (${project.projectKey})`}
              </Option>
            ))}
          </Select>
        </div>
        <div>
          <Text type='secondary' strong>
            Default Request type
          </Text>
          <br />
          <Select
            style={{ marginBottom: "8px", width: 300 }}
            name='defaultIssue'
            value={defaultIssueType.value}
            onChange={this.onChangeIssue}
            showSearch={true}
            disabled={editMode && defaultProject && defaultProject.id ? false : true}
          >
            {(useRestrictedRequestTypes ? restrictedRequestTypes : this.props.requestTypes).map((issue, index) => (
              <Option key={issue.value} value={issue.value} issueType={issue}>
                {issue.text}
              </Option>
            ))}
          </Select>
        </div> */}

        <div
          style={{
            // marginBottom: 16,
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <div>
            <div>
              <Text type='secondary' strong>
                Default Project
              </Text>
            </div>
            <Select
              style={{ width: 200, marginRight: 8 }}
              name='defaultProject'
              value={
                sub_skill === 'jira_software'
                  ? defaultProject.id
                  : defaultProject.projectId
              }
              onChange={this.onChangeProject}
              showSearch={true}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              disabled={!editMode}
              loading={projects && projects.length === 0}
            >
              {projectOptions}
            </Select>
          </div>

          {sub_skill === 'jira_software' && (
            <div>
              <div>
                <Text type='secondary' strong>
                  Default Issue type
                </Text>
              </div>
              <Select
                style={{ width: 200, marginRight: 8 }}
                name='defaultIssue'
                value={defaultIssueType.value}
                onChange={this.onChangeIssue}
                showSearch={true}
                disabled={
                  editMode && defaultProject && defaultProject.id ? false : true
                }
                loading={this.state.issueTypeLoading}
              >
                {this.props.issues.map((issue, index) => (
                  <Option
                    key={issue.value}
                    value={issue.value}
                    issueType={issue}
                  >
                    {issue.text}
                  </Option>
                ))}
              </Select>
            </div>
          )}

          {sub_skill === 'jira_service_desk' && (
            <div>
              <div>
                <Text type='secondary' strong>
                  Default Request type (optional)
                </Text>
              </div>
              <Select
                style={{ width: 200, marginRight: 8 }}
                name='defaultIssue'
                value={defaultIssueType.value}
                onChange={this.onChangeIssue}
                showSearch={true}
                allowClear
                disabled={
                  editMode && defaultProject && defaultProject.id ? false : true
                }
                loading={this.state.issueTypeLoading}
              >
                {(useRestrictedRequestTypes
                  ? restrictedRequestTypes
                  : this.props.requestTypes
                ).map((issue, index) => (
                  <Option
                    key={issue.value}
                    value={issue.value}
                    issueType={issue}
                  >
                    {issue.text}
                  </Option>
                ))}
              </Select>
            </div>
          )}
        </div>

        {this.props.isWorkspaceAdmin && (
          <div style={{ marginTop: 16 }}>
            {editMode ? (
              <>
                <Button
                  style={{ width: 100, marginRight: '10px' }}
                  loading={this.state.saveLoading}
                  disabled={
                    sub_skill === 'jira_software'
                      ? !defaultProject.id || !defaultIssueType.value
                      : !defaultProject.id
                  }
                  onClick={() => this.handleSave()}
                  type='primary'
                >
                  Save
                </Button>
                <Button
                  style={{ width: 100 }}
                  onClick={() => this.handleCancel()}
                >
                  Cancel
                </Button>
              </>
            ) : (
              <>
                <Button
                  style={{ width: 100 }}
                  onClick={() => this.setState({ editMode: true })}
                >
                  Edit
                </Button>
                {jiraSkill &&
                  jiraSkill.skill_metadata &&
                  jiraSkill.skill_metadata.globalDefaults &&
                  (sub_skill === 'jira_software'
                    ? jiraSkill.skill_metadata.globalDefaults.issueDefaults
                    : jiraSkill.skill_metadata.globalDefaults
                        .ticketDefaults) && (
                    <Popconfirm
                      title='Are you sure you want to delete request defaults?'
                      onConfirm={() => this.handleDelete()}
                      okText='Delete'
                      cancelText='No'
                      placement='top'
                    >
                      <Button
                        style={{ width: 100, marginLeft: 16 }}
                        danger
                        loading={this.state.saveLoading}
                      >
                        Delete
                      </Button>
                    </Popconfirm>
                  )}
              </>
            )}
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    projects: state.skills.projects,
    jsd_projects: state.skills.jsd_projects,
    requestTypes: state.skills.requestTypes,
    // currentSkill: state.skills.currentSkill,
    isWorkspaceAdmin: state.common_reducer.isAdmin,
    jiraSkill: state.skills.skills
      ? state.skills.skills.find((skill) => skill.key === 'jira')
      : null,
    issues: state.skills.issues,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getProject,
    getServiceDeskProject,
    getIssues,
    updateSkill,
  })(DefaultsSelection)
);
